import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

/**
 * 查询维修分类列表
 */
export function listRepairCategories(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/pms.queryRepairCategory',
      method: 'get',
      params: {
        ...params,
        communityId:getCommunityId()
      }
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve({
          data: res.data || [],
          total: res.total
        })
      } else {
        reject(new Error(res.msg || '获取分类列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 新增/修改维修分类
 */
export function saveOrUpdateRepairCategory(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/pms.saveOrUpdateRepairCategory',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '保存失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除维修分类
 */
export function deleteRepairCategory(ids) {
  return new Promise((resolve, reject) => {
    request({
      url: '/pms.deleteRepairCategory',
      method: 'post',
      data: {
        ids: Array.isArray(ids) ? ids : [ids],
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '删除失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
